import { render } from "./SettingsPage.vue?vue&type=template&id=1693085e"
import script from "./SettingsPage.js?vue&type=script&lang=js&external"
export * from "./SettingsPage.js?vue&type=script&lang=js&external"

import "./SettingsPage.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__